__turbopack_context__.v({
  "actionRow": "SongPage-module__XZezBG__actionRow",
  "composer": "SongPage-module__XZezBG__composer",
  "container": "SongPage-module__XZezBG__container",
  "cover": "SongPage-module__XZezBG__cover",
  "coverWrapper": "SongPage-module__XZezBG__coverWrapper",
  "icon": "SongPage-module__XZezBG__icon",
  "info": "SongPage-module__XZezBG__info",
  "playButton": "SongPage-module__XZezBG__playButton",
  "title": "SongPage-module__XZezBG__title",
});
